export class BrowserUploadedFile {
    legacy: File;
    contents: ArrayBuffer;

    constructor(legacy: File, contents: ArrayBuffer) {
        this.legacy = legacy;
        this.contents = contents;
    }
}
